import React, { useEffect, useState } from 'react';
import { DateShortInfo, EventShortInfo, ReportType } from '../../ReportsClasses';
import { Button, Groupper, Header, IconName, Message, Toast } from 'react-frontier';
import { Link } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';
import API from '../../ReportsAPI';
import moment from 'moment';

interface DateStatsReportsProps{
	event_id: number,
	event: EventShortInfo,
	date?: DateShortInfo,
}

interface ReportItem{
	title: string,
	description_date: string,
	description_event: string,
	icon: IconName,
	type: ReportType,
	filename: string,
}

var DateStatsReports = (props: DateStatsReportsProps)=>{
	var { t } = useTranslation();
	var [downloading, setDownloading] = useState<boolean>(false);
	var file_suffix = `${props.date ? 'D' : 'E' }${props.date?.date_id || props.event_id}`;

	const REPORTS : ReportItem[] = [{
		title: t('reports.sales.title'), 
		description_date: t('reports.sales.description_date'),
		description_event: t('reports.sales.description_event'),
		icon: 'file-pdf',
		type: 'sales',
		filename: `AREMA-S${file_suffix}.pdf`,
	}, {
		title: t('reports.orders.title'), 
		description_date: t('reports.orders.description_date'),
		description_event: t('reports.orders.description_event'),
		icon: 'file-csv',
		type: 'orders',
		filename: `AREMA-O${file_suffix}.csv`,
	}, {
		title: t('reports.tickets.title'), 
		description_date: t('reports.tickets.description_date'),
		description_event: t('reports.tickets.description_event'),
		icon: 'file-csv',
		type: 'tickets',
		filename: `AREMA-T${file_suffix}.csv`,
	}, {
		title: t('reports.sales_log.title'), 
		description_date: t('reports.sales_log.description'),
		description_event: t('reports.sales_log.description'),
		icon: 'file-csv',
		type: 'log',
		filename: `AREMA-L${file_suffix}.csv`,
	}]

	var downloadReport = (type: ReportType, filename: string)=>{
		return ()=>{
			var tid = Toast.show(t('reports.downloading'), { loading: true });
			setDownloading(true);
			API.getReportDownload(props.event_id, props.date?.date_id, type, filename).then(res=>{
				Toast.success(t('reports.downloaded'));
				if(res.error) return Toast.error(res.message);
			}).catch(err=>{
				Toast.error(t('common.unexpected_code', { code: 'ST-LCL-ESTRPT-1' }));
			}).finally(()=>{
				setDownloading(false);
				Toast.dismiss(tid);
			});
		}
	}

	// TODO: Fix translation descriptions that say "funcion"
	return <div className="ar date-stats-reports-screen">
		{!props.date && (
			<Header text={props.event.event_name} subtext={t('event_container.items.reports')} style={{ marginTop: 15 }} />
		)}
		{!!props.date && (
			<Message centered type='info' style={{ maxWidth: 400, margin: 'auto', marginBottom: 15 }}>
				<Trans i18nKey={'reports.date_message'} values={{ date: moment.unix(props.date.date).format('DD/MMM/YYYY HH:mm') }} />
				<br />
				<Button basic as={Link} to={`/miseventos/${props.event_id}/reports`} color='blue' style={{ marginTop: 10, width: 200 }} text={t('reports.date_button')} size='tiny' />
			</Message>
		)}
		<Groupper fitted title={t('reports.title')} style={{ margin: 'auto', maxWidth: 600 }}>
			<div className="ar options">
				{REPORTS.map((a,i)=>(
					<div className="option" key={`RPITM-${i}`}>
						<div className="info">
							<div className="title">{a.title}</div>
							<div className="description">{props.date ? a.description_date : a.description_event}</div>
						</div>
						<Button text='Descargar' iconName={a.icon} onClick={downloadReport(a.type, a.filename)} disabled={downloading} />
					</div>
				))}
			</div>
		</Groupper>
	</div>
}

export default DateStatsReports;